import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { EditorialMarquee } from "./components/EditorialMarquee";
import { About } from "./components/About";
import { CelebritySmiles } from "./components/CelebritySmiles";
import { InstagramReels } from "./components/InstagramReels";
import { Courses } from "./components/Courses";
import { IndiaMap } from "./components/IndiaMap";
import { Mentorship } from "./components/Mentorship";
import { FAQ } from "./components/FAQ";
import { Contact } from "./components/Contact";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.08, smoothWheel: true });
    const raf = (time) => {
      lenis.raf(time);
      requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);
    return () => lenis.destroy();
  }, []);

  return (
    <div className="App">
      <Navbar />
      <main>
        <Hero />
        <EditorialMarquee />
        <About />
        <CelebritySmiles />
        <InstagramReels />
        <Courses />
        <Mentorship />
        <IndiaMap />
        <FAQ />
        <EditorialMarquee dark />
        <Contact />
      </main>
    </div>
  );
}

export default App;
